export default __webpack_public_path__ + "static/media/garbage-option.9cce87c0.svg";